import { useEffect } from "react";

const Seo = ({ title, description, image }) => {
  useEffect(() => {
    document.title = title;
    const meta = document.querySelector('meta[name="description"]');
    if (meta && description) meta.setAttribute("content", description);
    if (image) {
      const og = document.querySelector('meta[property="og:image"]');
      if (og) og.setAttribute("content", image);
    }
  }, [title, description, image]);
  return null;
};

export default Seo;
